import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnInit,
    Renderer,
    AfterViewInit,
    ElementRef,
    animate, style, state, trigger, transition
} from '@angular/core';
import {Events, NavController, ViewController} from "ionic-angular";

@Component({
    selector: 'dice-jump',
    templateUrl: 'diceJump.html',
    animations: [
        trigger('flyInOut', [
            state('inactive', style({
                opacity: 0,
                transform: 'scale(0.7)'
            })),
            state('active', style({
                opacity: 1,
                transform: 'scale(1)'
            })),
            transition('inactive => active', animate('100ms ease-in')),
        ])
    ]
})
export class DiceJumpComponent implements OnInit, AfterViewInit {
    public statusBet: number = 0;
    static diceTimer: any;
    public elDice: any;
    public elDiceWrap: any;
    public isTrace: boolean = false;
    public pageDome: HTMLElement;
    public state: string = 'inactive';
    public countDown: number = 0;
    public countTemp: number = 0;
    public timerClose: any;
    public timerAni: any;
    @Output() closeAniDiceJump: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    set dataTaiXiuWin(dataDiceWin: any) {
        if (dataDiceWin) {
            console.log("vao dataTaiXiuWin", dataDiceWin);
            
            clearTimeout(this.timerClose);
            let data = dataDiceWin.dataApi;
            this.statusBet = data.success;
            this.isTrace = dataDiceWin.goIssues.isGo;
            this.countTemp += 1;
            this.countDown = dataDiceWin.goIssues.totalNum - this.countTemp;

            clearTimeout(this.timerAni);
            this.timerAni = setTimeout(() => {
                this.state = 'active';
                this.elDice = this.pageDome.querySelectorAll('.dice');
                this.elDiceWrap = this.pageDome.querySelector('.classes');
                this.aniDice();
                this.jumpStop(data);
            }, 500);
        }
    }

    constructor(public renderer: Renderer, public viewCtrl: ViewController, public events: Events, public el: ElementRef, public navCtrl: NavController){
        this.pageDome = el.nativeElement;
    }

    ngOnInit() {}

    ngAfterViewInit() {}

    aniDice() {
        let hElDiceEach = this.elDice[0].offsetHeight;
        let wElDiceEach = this.elDice[0].offsetWidth;
        let hElDiceWrap = this.elDiceWrap.offsetHeight;
        let wElDiceWrap = this.elDiceWrap.offsetWidth;
        let wRecent = wElDiceWrap - wElDiceEach;
        let hRecent = hElDiceWrap - hElDiceEach;
        let f = 0, d = 50, p = 50, h = -50;

        clearInterval(DiceJumpComponent.diceTimer);
        DiceJumpComponent.diceTimer = setInterval(() => {
            for (let i = 0, len = this.elDice.length; i < len; i++) {
                this.elDice[i].className = '';
                this.elDice[i].className = 'dice dice-'+ this.getRandom(1, 6);
                this.elDice[i].style.top = this.getRandom(d, hRecent + h) +'px';
                this.elDice[i].style.left = this.getRandom(p, wRecent + f) +'px';
            }
        }, 100);
    }

    getRandom(start, end) {
        return Math.floor(Math.random() * (end - start + 1) + start);
    }

    jumpStop(dataApi) {
        let posiDice = dataApi.data.result.split('|');
        let posiResultDice = [
                {x: 90, y: 115},
                {x: 150,y: 115},
                {x: 210,y: 115}
            ];

        // time out waiting jump dice
        setTimeout(() => {
            clearInterval(DiceJumpComponent.diceTimer);
            for (let i = 0, len = this.elDice.length; i < len; i++) {
                this.elDice[i].className = '';
                this.elDice[i].className = 'dice dice-'+ posiDice[i];
            }
            setTimeout(() => {
                for (let i = 0, len = this.elDice.length; i < len; i++) {
                    this.elDice[i].style.left = posiResultDice[i].x +'px';
                    this.elDice[i].style.top = posiResultDice[i].y +'px';
                }
                setTimeout(() => {
                    this.jumpClose();
                }, 1000);
            }, 1000);
        }, 3500);
    }

    jumpClose() {
        this.state = 'inactive';
        clearTimeout(this.timerClose);
        this.timerClose = setTimeout(() => {
            this.statusBet = 0;
            if (this.countDown > 0) {
                clearTimeout(this.timerAni);
                this.events.publish('taixiu:CloseJumpEmu', {});
            }else {
                this.isTrace = false;
                this.countTemp = 0;
                this.closeAniDiceJump.emit('closeJump');
            }
        }, 200);
    }

    stopTraceBtn(event: any) {
        this.jumpClose();
        this.countDown = 0;
    }
}


// WEBPACK FOOTER //
// ./src/component/gameTaiXiu/diceJump/diceJump.ts